import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { setFeatureFlag } from '../../../containers/Pages/Edd/EddUtils';

function EddSplashScreen(props) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const { show, setShowSplashPopup } = props;

  return show ? (
    <div className="flex justify-center fixed items-center w-screen h-screen backdrop-blur-sm bg-transparent left-0 top-0 bg-opacity-50 z-40">
      <div className="w-[750px] z-50 bg-white rounded-[30px] h-[440px] shadow-lg flex flex-col items-center translate-x-[90px]">
        <div className="flex justify-end w-[750px]">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={async () => {
              setShowSplashPopup(0);

              if (doNotShowAgain) {
                await setFeatureFlag();
              }
            }}
          >
            <i className="material-icons text-[24px] m-2 !text-inherit">close</i>
          </button>
        </div>

        <h2 className="text-center font-bold text-2xl text-slate-700">
          This is a <span className="text-primary">FREE</span> preview of our new{' '}
          <span className="text-primary">EDD</span> Feature
        </h2>
        <p className="text-center justify-center text-xs  text-slate-800  mt-8 px-4">
          <span className="text-primary font-bold">EDD</span> Lets you create and update Tags,
          Playlists, Assignments, Schedules, or Sequences using an Excel spreadsheet or CSV file{' '}
        </p>
        <p className="text-center justify-center text-xs  text-slate-800 mt-8 px-4">
          It&apos;s perfect for making bulk changes quickly and efficiently, simply upload your
          file, specify when you&apos;d like the changes to be imported and{' '}
          <span className="text-primary font-bold">EDD</span> will take care of the rest in seconds
        </p>

        <div className="flex space-x-6 justify-center mt-8">
          <div className="flex flex-col items-center">
            <img
              src="/assets/images/icons/splashscreen_book.svg"
              width={84}
              height={84}
              alt="documentation"
              className="duration-500 hover:scale-x-105 hover:scale-y-105 cursor-pointer"
            />
            <p className="w-[124px] text-xs font-bold text-slate-600 text-center justify-center">
              Read the documentation
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src="/assets/images/icons/splashscreen_file_spreadsheet.svg"
              width={84}
              height={84}
              alt="CSV or Excel file"
              className="duration-500 cursor-pointer"
            />
            <p className="w-[124px] text-xs font-bold text-slate-600 text-center justify-center">
              Create a CSV or Excel file for your desired asset type
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src="/assets/images/icons/splashscreen_cloud_check.svg"
              width={84}
              height={84}
              alt="validate and check"
              className="cursor-pointer"
            />
            <p className="w-[124px] text-xs font-bold text-slate-600 text-center justify-center">
              Edd will validate and alert you to any errors
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src="/assets/images/icons/splashscreen_file_import.svg"
              width={84}
              height={84}
              alt="import file"
              className="cursor-pointer"
            />
            <p className="w-[124px] text-xs font-bold text-slate-600 text-center justify-center">
              Import the file now or schedule it for import later
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src="/assets/images/icons/splashscreen_schedule_deploy.svg"
              width={84}
              height={84}
              alt="schedule deploy"
              className="cursor-pointer"
            />
            <p className="w-[124px] text-xs font-bold text-slate-600 text-center justify-center">
              Deploy the file now or schedule it to deploy later
            </p>
          </div>
        </div>

        <div className="flex justify-center items-center mt-4 pb-2">
          <input
            checked={doNotShowAgain}
            onChange={() => setDoNotShowAgain(!doNotShowAgain)}
            type="checkbox"
            placeholder="Do not show this again"
            className="mr-2 text-dark-night"
          />
          <button
            type="button"
            data-test="edd-splash-screen-do-not-show-again"
            className="text-xs ml-2  text-slate-600 cursor-pointer active:text-slate-400"
            onClick={async () => {
              setShowSplashPopup(0);
              await setFeatureFlag();
              setDoNotShowAgain(prev => !prev);
            }}
          >
            Do not show this again
          </button>
        </div>
      </div>
    </div>
  ) : null;
}

EddSplashScreen.propTypes = {
  show: PropTypes.number.isRequired,
  setShowSplashPopup: PropTypes.func.isRequired,
};

export default EddSplashScreen;
